import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { alert_error, alert_success } from './../../AppContext';
import { Cookies } from './../../index.js';
import { Helmet } from "react-helmet";
import History_main from "./history_main";
import Pay from "./pay";
import Page from "./page";
import { ClipLoader } from "react-spinners";
import Post_content from '../../community/content/Blog_posts.jsx';
import ProfileNav from "../../app_structure/tabs_nav/ProfileNav.jsx";
const InviteFriends = () => {
    const { slug_1 , slug_2 } = useParams();
    const [profile, setprofile] = useState('');
    const [link_ref, setlink_ref] = useState('');
    useEffect(() => {
        // Kiểm tra xem có giá trị "apikey" trong AsyncStorage không
    }, []);
    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);
    };
    return (
        <>
            <div className=" mt-2">
                <Helmet>
                    <title>Hust Media Affiliate</title>
                </Helmet>
                <ProfileNav category='referrals' />
                {(slug_2 == 'history_vip_3' || slug_2 == 'history_vip_2' || slug_2 == 'history_vip_1' || slug_2 == 'cash_diary') ? (<><History_main /></>)
                    : (<>
                        {slug_1 == 'pay' ? (
                            <Pay />
                        ) :
                            (<>  {slug_1 == 'guide' ? (
                                <Post_content mode={'hust_media'} show_adsense={'YES'} show_adskeeper={'NO'} uri={'referrals_guide'} />
                            ) :
                                (<> <Page /></>)
                            }</>)
                        }</>)}
            </div>
        </>

    );
};

export default InviteFriends;
